import NoPermissionMessage from './NoPermissionMessage';
import { checkForPermission, checkFeaturePermission } from '../../util/permissionUtils';

interface ProtectedRouteProps {
  children: any;
  featureName?: any;
  allOperations?: any;
}
const ProtectRoute = ({
  children,
  featureName = '',
  allOperations = true
}: ProtectedRouteProps) => {
  return checkFeaturePermission(featureName, allOperations) ? children : <NoPermissionMessage />;
};

export default ProtectRoute;
